function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Tab from "@mui/material/Tab";
//Limitless imports
import Typography from "@limitless/modern/data-display/typography/Typography";
const useStyles = makeStyles(theme => ({
  tab: {
    minHeight: 56,
    minWidth: 100,
    marginRight: ({
      isMandatory
    }) => isMandatory ? "10px" : "",
    overflow: ({
      isMandatory
    }) => isMandatory ? "initial" : ""
  },
  mandatory: {
    color: theme.palette.error.dark,
    display: "inline-flex",
    position: "absolute",
    top: 0,
    right: -10
  },
  largeMandatory: {
    fontSize: 22,
    color: theme.palette.error.dark,
    display: "inline-flex",
    position: "absolute",
    top: -3,
    right: -14
  },
  hide: {
    display: "none"
  },
  rootTab: {
    textTransform: "initial",
    alignItems: "baseline",
    padding: "12px 16px 12px 0px!important",
    minWidth: "0px!important",
    marginRight: "10px!important"
  }
}));
const ConversationTab = ({
  label,
  id,
  hide,
  mandatory,
  largeMandatory,
  ...rest
}) => {
  const classes = useStyles({
    isMandatory: mandatory || largeMandatory
  });
  return /*#__PURE__*/React.createElement(Tab, _extends({
    id: id,
    classes: {
      fullWidth: classes.tab,
      root: classes.rootTab
    },
    disableRipple: true,
    label: /*#__PURE__*/React.createElement(Typography, {
      component: "span",
      variant: "subtitle1",
      sx: {
        color: theme => rest.selected ? theme.palette.text.primary : theme.palette.text.secondary,
        position: "relative"
      }
    }, label, mandatory && /*#__PURE__*/React.createElement("div", {
      className: `${largeMandatory ? classes.largeMandatory : classes.mandatory}`
    }, "*")),
    className: `${hide ? classes.hide : ""}`
  }, rest));
};
export default ConversationTab;
ConversationTab.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  hide: PropTypes.bool,
  mandatory: PropTypes.bool,
  largeMandatory: PropTypes.bool
};
ConversationTab.defaultProps = {
  hide: false,
  mandatory: false,
  largeMandatory: false
};